var _circle, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6865,
    cy: 22.6588,
    r: 22.6588,
    fill: "#A32801"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.88,
    height: 26.88,
    transform: "translate(8.69873 8.96951)",
    fill: "#A32801"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4684 14.7392C14.9932 14.2143 15.8442 14.2143 16.3691 14.7392L22.1387 20.5088L27.9084 14.7392C28.4332 14.2143 29.2842 14.2143 29.8091 14.7392C30.3339 15.264 30.3339 16.115 29.8091 16.6399L24.0394 22.4095L29.8091 28.1792C30.3339 28.704 30.3339 29.555 29.8091 30.0799C29.2842 30.6047 28.4332 30.6047 27.9084 30.0799L22.1387 24.3102L16.3691 30.0799C15.8442 30.6047 14.9932 30.6047 14.4684 30.0799C13.9435 29.555 13.9435 28.704 14.4684 28.1792L20.238 22.4095L14.4684 16.6399C13.9435 16.115 13.9435 15.264 14.4684 14.7392Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e2eab9be9999d25bec5dce89205fa439.svg";
export { ForwardRef as ReactComponent };